<template>
  <div class="wrapper">
    <van-list
      id="scroll"
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="getdata(pageIndex + 1)"
      :immediate-check="false"
      :offset="20"
    >
      <div class="noData" v-show="list.length == 0">
        <img src="./../../assets/images/kb.png" alt>
        <div>暂无数据</div>
      </div>
      <div class="item" v-for="(item,index) in list" :key="index" @click="toNewsDetail(item.nbr)">
        <img class="itemImg" v-lazy="item.cover" alt="">
        <div class="right">
          <p class="title">{{item.title}}</p>
          <div class="desc" >
            <span>{{item.author}}</span>
            <span style="margin-left: .2rem">{{item.create_time}}</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  mixins: [weChatShareApi],
  data(){
    return {
      list:[],
      pageIndex:0,
      numPerPage:10,
      loading: false,
      finished: false,
      keepAlive:true,
      scroll:0,
    }
  },
  methods:{
    toNewsDetail(nbr){
      this.$router.push({ path: `/newsDetail/${nbr}` })
    },
    getdata(index) {
      let list = this.list
      if(index==0){
        list=[]
      }
      this.pageIndex = index;
      this.$commonPost({
        jydm: "flow_160003",
        flow_160003: {
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage,
        }
      }).then((res) => {
        if (res.resp_code == "0" && res.resp_result == "0") {
          let arr = [];
          if (res.list) {
            if (res.list.length > 0) {
              arr = res.list;
            } else {
              arr.push(res.list);
            }
          }
          arr.forEach((item)=>{
            item.create_time = item.create_time.substring(0, 10);
            item.update_time = item.update_time.substring(0, 10);
          })
          this.list = list.concat(arr);
          if (arr.length < this.numPerPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          this.loading = false;
        } else {
          this.$toast({
            message: res.resp_msg,
            duration: 2000,
          });
        }
        })
        .catch((err) => {
          this.$toast({
            message: "您现在的网络不稳定，请稍后再试",
            duration: 2000,
          });
        });
    },
  },
  watch: {
    $route(to, from) {
      if (from.name == "newDetail") {
        this.keepAlive = false;
      } else {
        this.keepAlive = true;
      }
    }
  },
  activated() {
    document.title = "商学院";
    if (this.keepAlive) {
//      document.getElementById('scroll').scrollTop = 0
      this.loading = true;
      this.getdata(0);
    }else{
      document.getElementById("scroll").scrollTop = this.scroll;
      return false;
    }
    let option = {
      title: '有米@'+this.userInfo.name+'的店铺',
      desc: "欢迎光临我的店铺",
      link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      images: this.userInfo.imgUrl,
    };
    this.weChatShare(option)
  },
  beforeRouteLeave(to, from, next) {
    this.scroll = document.getElementById("scroll").scrollTop;
    next();
  },
  mounted() {
  },
}
</script>

<style scoped lang='less'>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f9fafe;
}
.item{
  width: 100%;
  height: 2.2rem;
  background: #fff;
  box-sizing: border-box;
  padding: 0 .2rem;
  border-bottom:1px solid #eee;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .itemImg{
    width: 2.6rem;
    height: 1.6rem;
    margin-right: .2rem;
    object-fit: cover;
  }
  .right{
    width: 4.3rem;
    height: 2.2rem;
    box-sizing: border-box;
    padding: .3rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title{
      width: 4.3rem;
      line-height: 0.42rem;
      height: 0.84rem;
      font-size: 0.3rem;
      color: #333;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .desc{
      display: flex;
      flex-direction: row;
      align-items: center;
      span{
        line-height: 0.4rem;
        font-size: 0.28rem;
        color: #999;
        font-weight: 500;
      }
    }
  }
}

.noData {
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    width: 3.46rem;
    height: 2.1rem;
    margin-bottom: 0.2rem;
  }
}
</style>
<style scoped lang='stylus'>
  .desc >>> p,.desc >>> span{
    font-size: 0.2rem !important;
    color: #999 !important;
    line-height: 0.28rem !important;
    white-space: pre-line;
  }
</style>



// WEBPACK FOOTER //
// src/components/information/news.vue